import { render, staticRenderFns } from "./bluetoothLink.vue?vue&type=template&id=605e2922&"
import script from "./bluetoothLink.vue?vue&type=script&lang=js&"
export * from "./bluetoothLink.vue?vue&type=script&lang=js&"
import style0 from "./bluetoothLink.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports